<dxp-modal content-id="modal-1" cancel-button=false button-position="right" demo="false" demo-button-text='Show Modal'
footer-type="no-button" #modalReference width="650" close-on-outside-click="false" id="cancellation-modal">
<div class="dxp-row dxp-bg-initial">
    <div class="dxp-bg-initial dxp-col-md-12">
        <dxp-flex-layout>
            <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="0px 0px 18px 0px">
                <h4 class="dxp-bold dxp-pt-4">{{this.cancellationTitle}}</h4>
                <p>{{msg.ProcessUnpaidTransactions.SelectReason}}</p>
            </dxp-flex-layout-item>
        
            <dxp-flex-layout-item slot="column-2" column-width-lg="6" column-width-lg="6" padding-style-sm="0px 10px 15px 0px">
                <dxp-multi-selector selector-id="cancellationReason" data-source-key-name="description"
                    [items]="this.cancellationReasonList"
                    placeholder="{{msg.PlaceHolders.SelectOptions}}" label="Reason for cancellation"
                    (selectedOptions)="setCancellationReason($event)" multi-search="true" max-limit="1"
                    list-aria-label="Reason for cancellation" #cancellationReasonRefrence>
                </dxp-multi-selector>
                <span class="form-validation-error" *ngIf="this.selectCancellationReason">
                    {{msg.ProcessUnpaidTransactions.SelectCancellationReason}}
                </span>
            </dxp-flex-layout-item>
            <dxp-flex-layout-item slot="column-3" column-width-lg="6" column-width-lg="6" padding-style-sm="0px 0px 15px 10px">
                <dxp-input input-id="rspReferenceID" type="text" label="RSP reference id" maxlength="100"
                    accessibility-text="Enter RSP reference ID" [optional]="this.rspReferenceIdOptional" placeholder="Enter RSP reference id"
                    restrict=true list-aria-label="Text input to set RSP reference id" (textValue)="setRspReferenceID($event)"
                    (valueCleared)="clearRspReferenceID()" #rspReferenceIDReference>
                </dxp-input>
                <span class="form-validation-error" *ngIf="this.selectRefrenceId">
                    {{msg.ProcessUnpaidTransactions.SelectReferenceID}}
                </span>
            </dxp-flex-layout-item>
        
            <dxp-flex-layout-item slot="column-4" column-width-lg="12" column-width-lg="12" padding-style-sm="0px 0px 15px">
                <dxp-textarea value="" optional="true" placeholder="Enter description" label="Note" rows="4" cols="40"
                    accessibility-text="Insert note" (changeText)="setNotes($event)" #notesTextAreaReference>
                </dxp-textarea>
                <span [ngClass]="(noteMaxLengthValid == 'invalid') ? 'cancel-validation-error' : 'dxp-font-clr'">Maximum 200 characters are allowed</span>
            </dxp-flex-layout-item>
            <dxp-flex-layout-item slot="column-5" column-width-sm="12" column-width-lg="12" padding-style-sm="10px 0px 30px">
                <p class="title-size-14">Select method(s) of cancellation delivery</p>
                <dxp-checkbox label="Keep charges OI" (checkboxData)="setKeepChargesOI($event)" [checked]="this.keepChargesOI" [disabled]="this.keepChargesOiDisabled"
                    aria-label="Checkbox for Keep charges OI" #rspKeepChargesOiReference></dxp-checkbox>
                <dxp-checkbox label="Transmit to OI" (checkboxData)="setTransmitToOI($event)" [checked]="this.transmitToOI"
                    aria-label="Checkbox for Transmit to OI"></dxp-checkbox>
                <dxp-checkbox label="Email OI" (checkboxData)="setEmailOI($event)" [checked]="this.emailOI"
                    aria-label="Checkbox for Email OI"></dxp-checkbox>
            </dxp-flex-layout-item>
        
        </dxp-flex-layout>
        <dxp-flex-layout>
            <dxp-flex-layout-item slot="column-1" column-width-sm="3" column-width-lg="2" padding-style-sm="0px 25px 0px 0px">
                <dxp-button type="primary" button-id="btnProcessCancel" text="Process" state="enabled" aria-label="Process"
                    button-title="Process" (click)="processCancellation()"></dxp-button>
            </dxp-flex-layout-item>
            <dxp-flex-layout-item slot="column-2" column-width-sm="3" column-width-lg="2" padding-style-sm="0px 0px 0px 25px">
                <dxp-button type="secondary" button-id="btnCancel" text="Cancel" state="enabled" button-title="Cancel"
                    (click)="closeCancelModal()"></dxp-button>
            </dxp-flex-layout-item>
        </dxp-flex-layout>
    </div>
</div>
</dxp-modal>
<confirmation-modal></confirmation-modal>

